/**
 * Refresh if our app version has changed
 * safari bug doesn't size srcset when loaded over ajax
 * https://www.debugcn.com/en/article/16843265.html
 */
const getVersionFromHtml = function(html) {
    try {
        const meta = html.querySelector('meta[name="X-App-Version"]');
        return meta.getAttribute('content');
    } catch(e) {
        up.log.warn('app:getVersionFromHtml', e.message);
      return '0.0.0:0';
    }
};
  
const currentVersion = getVersionFromHtml(document);
console.log('app:currentVersion', currentVersion);
  
// reload if new build version detected
up.on('up:fragment:loaded', (event) => {
    try {
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(event.response.text, 'text/html');
        const responseVersion = getVersionFromHtml(parsedHtml);
        up.log.puts('app:responseVersion', responseVersion);
        if(responseVersion !== currentVersion) {
            throw new Error('New version detected: ' + responseVersion + ' !== ' + currentVersion);
        }
    } catch(e) {
        up.log.warn('app:versionMismatch', e.message);
        up.cache.expire();
        event.preventDefault();
        return event.request.loadPage();
    };
});

/**
 * Videos break in Safari when they are injected into the DOM.
 * - Only binds event if Safari browser
 * - `initialLoad` flag avoids our code running on initial page render
 * - Query for all video elements inside fragment
 * - Overwriting its `outerHTML` forces Safari to re-render the video.
 */
const isSafari = () => {
    const ua = navigator.userAgent;
    console.log(`User Agent: ${ua}`);
    return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('CriOS') && !ua.includes('FxiOS');
};

if (isSafari()) {
    let initialLoad = true;
    up.on('up:fragment:inserted', (event, fragment) => {
        if (initialLoad) {
            initialLoad = false;
            return;
        }

        const videos = fragment.querySelectorAll('video');
        if (videos.length === 0) return;

        videos.forEach((video) => {
            video.outerHTML = video.outerHTML;
        });
    });
}

/**
 * Smooth scroll to target
 */
// Easing functions defined with arrow syntax

const easeOutCirc = x => Math.sqrt(1 - Math.pow(x - 1, 2));
const easeInOutCubic = x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
const easeInOutQuad = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
const easeInOutQuart = x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
const easeInOutQuint = x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
const easeOutExpo = x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
const easeInOutSine = x => -(Math.cos(Math.PI * x) - 1) / 2;

// Custom scrollTo function with easing
const customScrollTo = (targetPosition, offset, duration = 1000, easingFunction = easeOutCirc) => {
    const startPosition = window.scrollY || window.pageYOffset;
    const distance = targetPosition - offset - startPosition;
    let startTime = null;

    const animation = currentTime => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Cap progress at 1

        // Apply the selected easing function
        const easedProgress = easingFunction(progress);

        // Calculate current scroll position based on easing
        const currentScroll = startPosition + distance * easedProgress;

        // Scroll to the current position
        window.scrollTo(0, currentScroll);

        // Continue the animation until the time has elapsed
        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    };

    // Start the animation
    requestAnimationFrame(animation);
}

// Alpine or Unpoly integration
up.compiler('[data-scroll-to-target]', function(fragment) {
    const offset = parseInt(fragment.getAttribute('data-scroll-to-target')) || 0;
    const fragmentTop = fragment.getBoundingClientRect().top + window.scrollY;

    // Switch the easing function here to test different ones
    customScrollTo(fragmentTop, offset, 1000, easeInOutCubic); // You can replace with easeOutCirc, easeOutExpo, easeInOutSine, etc.
});
